import template from './rw-privacy-policy.html';

export default {
  template,
  controller: 'RwPrivacyPolicyController',
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-privacy-policy/rw-privacy-policy-component.js